import { gql, useMutation } from '@apollo/client'

import { cleanRequest } from './cleanRequest'
import { generalClient } from '../../../../../../utils/apollo/api'
import { useNotification } from '@btime/react-messager'

const MUTATION = gql`
  mutation UpsertConfig($input: ConfigInput) {
    upsertConfig(input: $input) {
      id
    }
  }
`

export const useSaveDocumentHeader = () => {
  const notify = useNotification()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Config', 'Configs'], client: generalClient })

  const handleRequest = image => {
    const input = cleanRequest(image, 'default_pdf_document_header')
    return request({ variables: { input } }).then(resp => {
      if (!resp.errors) {
        notify.success({ title: 'Imagem salva com sucesso!' })
      } else {
        notify.error({ title: 'Ocorreu um erro ao salvar imagem!' })
      }
    })
  }

  return [handleRequest, state]
}
